import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=7197f676&"
import script from "./VehicleInfo.vue?vue&type=script&lang=ts&"
export * from "./VehicleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardTitle,VDialog,VIcon})
